export const getDefaultHeaders = (repairId?: string) => {
  const headers: Record<string, string> = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  if (repairId) {
    headers['X-Repair-Id'] = repairId;
  }
  return headers;
};
